import type { MediaType } from "../media/MediaPicker";

export type TopicImageFormat = number;

export enum FormFieldType {
  Text = "text",
  Textarea = "textarea",
  RichText = "richText",
  List = "list",
  Image = "image",
  Select = "select",
  MultiSelect = "multiSelect",
  Number = "number",
  ImageUpload = "imageUpload",
  Switch = "switch",
  CompactList = "compactList",
  Media = "media",
}

interface ShowCondition {
  when: string;
  is: string | string[];
}

export interface FormConfig {
  name: string;
  label: string;
  placeholder?: string;
  type: FormFieldType;
  settings?: {
    rows?: number;
    format?: TopicImageFormat;
    options?: Record<string, string>;
    nullOption?: boolean;
    show?: ShowCondition;
    hideForViewer?: boolean;
    mediaType?: MediaType;
  };
}
